import { Size } from 'ff-canvas';

export const maintainAspectRatioOf = (
    source: Size,
    target: Size
): Size => {
    return target.width > target.height
        ? applyRatioToWidthOf(target, source)
        : applyRatioToHeightOf(target, source);
};

const applyRatioToWidthOf = (
    target: Size,
    source: Size
): Size => {

    const sourceSizeRatio = source.height / source.width;
    const thumbnailSizeRatio = target.height / target.width;

    return {
        width: source.width * (sourceSizeRatio / thumbnailSizeRatio),
        height: source.height
    };
};

const applyRatioToHeightOf = (
    target: Size,
    source: Size
): Size => {

    const sourceSizeRatio = source.width / source.height;
    const thumbnailSizeRatio = target.width / target.height;

    return {
        width: source.width,
        height: source.height * (sourceSizeRatio / thumbnailSizeRatio)
    };
};